import { NavigationData } from 'core/slices/models';

export function hasPbiReportId(
  navData: NavigationData,
  reportId: string
): boolean {
  const search = (nodes: any[]): boolean =>
    nodes?.some(
      node =>
        (node.nodeType === 'report' && node.pbiView?.id === reportId) ||
        (node.children && search(node.children))
    );
  return search(navData.children);
}
